export default "__VITE_ASSET__BKdGA6Xo__"